var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuContact = function SvgMenuContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Menu-Contact_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Menu-Contact_svg__st1{fill:#666}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 51.2c-134 0-243 109-243 243s109 243 243 243 243-109 243-243-109-243-243-243M814.3 696C747.8 628.4 659.6 591.2 566 591.2H458c-93.6 0-181.8 37.2-248.3 104.8C143.5 763.2 107 851.9 107 945.8c0 14.9 12.1 27 27 27h756c14.9 0 27-12.1 27-27 0-93.9-36.5-182.6-102.7-249.8",
    className: "Menu-Contact_svg__st1"
  })));
};
export default SvgMenuContact;